import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactXlsxExport from 'react-xlsx-export';

import Accordion from '@material-ui/core/Accordion';
import AccordionActions from '@material-ui/core/AccordionActions';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Alert from "@material-ui/lab/Alert"

import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

const TransportationRequestAccordion = ({ label, Icon, Chips, Details, reservationReqId }) => {
  const [items, setItems] = React.useState({
    items: [],
    loading: true,
    error: ''
  });
  const [uploadSuccess, setUploadSuccess] = useState({
    loading: false,
    uploaded: false,
    error: false
  });
  const [, setError] = useState(null);
  const [user] = useState(checkTokenExpirationMiddleware());

  let headers = {
    Authorization: `Bearer ${user.Token}`
  };

  const fileChangeHandler = async event => {
    if (!event.target.files[0]) {
      return;
    }
    const formData = new FormData();

    formData.append('excel', event.target.files[0]);

    setUploadSuccess({ loading: true, uploaded: false, error: false });

    const response = await fetch(
      `${process.env.REACT_APP_API}/api/TransportationOffer/PostExcelSheetAsync`,
      {
        method: 'POST',
        body: formData,
        headers: headers
      }
    );
    const result = await response.json();

    console.log({ result: response.status });

    if (response.status === 400) {
      setUploadSuccess({ loading: false, uploaded: false, error: true, message: result.message });
    } else {
      setUploadSuccess({ loading: false, uploaded: true, error: false });
    }
  };

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API}/api/TransportationOffer/GetExcelDataAsync/${reservationReqId}`,
        { headers: headers }
      )
      .then(({ data }) => {
        setItems({
          items: data.map(data => ({
            id: data.id,
            goingFromDestinationName: data.goingFromDestinationName,
            goingToDestinationName: data.goingToDestinationName,
            detailedAddress: data.detailedAddress,
            vehicleType: data.vehicleType,
            goingDate: data.goingDate,
            goingTime: data.goingTime,
            contactPerson: data.contactPerson,
            contactPersonTel: data.contactPersonTel,
            noofPersons: data.noofPersons,
            stop1: data.stop1,
            stop2: data.stop2,
            stop3: data.stop3,
            stop4: data.stop4,
            finalDestinationAddress: data.finalDestinationAddress,
            note: data.note,
            plannedTransportationBudget: data.plannedTransportationBudget,
            price: ''
          })),
          loading: false,
          error: ''
        });
      })
      .catch(err => {
        setError({ error: 'Error Loading page' });
        setItems({
          items: [],
          loading: false,
          error: 'error'
        });
      });
  }, [reservationReqId]);

  return (
    <>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className="bg-light-grey">
          {Icon}
          <Typography style={{ marginLeft: `4px`, marginRight: `8px` }}>{` ${label} `}</Typography>
          {Chips}
        </AccordionSummary>
        <Divider />

        <AccordionActions>
          <Grid item container>
            {items.loading ? (
              <p>Excel loading</p>
            ) : items.error ? (
              <p>error in Excel</p>
            ) : (
              <ReactXlsxExport
                data={items.items}
                styles={{
                  padding: '15px 15px',
                  margin: 0,
                  color: '#3f51b5',
                  width: '100%',
                  justifyContent: 'center',
                  border: '1px solid rgba(63, 81, 181, 0.5)',
                  borderRadius: '4px',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHight: 1.75
                }}
                filename="file"
              />
            )}
          </Grid>

          <Grid item container>
            <input
              onChange={fileChangeHandler}
              label="upload excel"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style={{
                padding: '10px 15px',
                margin: 0,
                color: '#3f51b5',
                width: '100%',
                justifyContent: 'center',
                border: '1px solid rgba(63, 81, 181, 0.5)',
                borderRadius: '4px',
                fontWeight: 400,
                fontSize: '14px',
                lineHight: 1.75
              }}
              id={`excel-1`}
              type="file"
            />
          </Grid>
        </AccordionActions>

        <AccordionActions>
          <Grid container>
            {uploadSuccess.loading ? ( //
              <p>Loading...</p>
            ) : uploadSuccess.error ? (
              <Alert variant="filled" severity="error">
                {uploadSuccess.message}
              </Alert>
            ) : uploadSuccess.uploaded ? (
              <Alert variant="filled" severity="success">
                Upload excel Successfully
              </Alert>
            ) : null}
          </Grid>
        </AccordionActions>
        <Divider />
        <AccordionDetails style={{ flexDirection: `column` }}>{Details}</AccordionDetails>
      </Accordion>
    </>
  );
};

export default TransportationRequestAccordion;
